// preparations.js
import { ref } from 'vue'

// by convention, composable function names start with "use"
export function usePreparations() {
  // state encapsulated and managed by the composable
  const coffee_preparations_base = [
    {
      display: 'Espresso',
      subtitle: 'Fine',
      image: '/assets/icons/misc/espresso.svg',
      value: 'espresso machine',
      valueBE: 'espresso_machine',
      coffee_type: 'espresso',
      grind_size: 'fine',
    },
    {
      display: 'Cafetiere',
      subtitle: 'Coarse',
      image: '/assets/icons/misc/cafetiere.svg',
      value: 'cafetiere',
      valueBE: 'cafetiere',
      coffee_type: 'brewed',
      grind_size: 'coarse',
    },
    {
      display: 'V60',
      grind_display: 'Medium',
      image: '/assets/icons/misc/drip.svg',
      value: 'v60',
      valueBE: 'v60',
      coffee_type: 'brewed',
      grind_size: 'medium',
    },
    // {
    //   display: 'Chemex',
    //   subtitle: 'Medium',
    //   image: '/assets/icons/misc/Chemex.svg',
    //   value: 'chemex',
    //   valueBE: 'chemex',
    //   coffee_type: 'brewed',
    //   grind_size: 'medium',
    // },
    {
      display: 'Clever Dripper',
      subtitle: 'Coarse',
      image: '/assets/icons/misc/clever-dripper.svg',
      value: 'clever-dripper',
      valueBE: 'clever_dripper',
      coffee_type: 'brewed',
      grind_size: 'coarse',
    },
    {
      display: 'Stove Top',
      subtitle: 'Medium-Fine',
      image: '/assets/icons/misc/stovetop.svg',
      value: 'stovetop',
      valueBE: 'stovetop',
      coffee_type: 'brewed',
      grind_size: 'medium_fine',
    },
    {
      display: 'AeroPress',
      subtitle: 'Medium-Fine',
      image: '/assets/icons/misc/Aeropress.svg',
      value: 'aeropress',
      valueBE: 'aeropress',
      coffee_type: 'brewed',
      grind_size: 'medium_fine',
    },
  ]
  const accordion_coffee_preparations_base = [{
    display: 'Bean to Cup',
    subtitle: 'Wholebean',
    image: 'https://res.cloudinary.com/pactcoffee/image/upload/v1617792589/website-d2c/assets/uploadedCMS/2021/Funnel/Bean_to_Cup.svg',
    value: 'bean to cup',
    valueBE: 'bean_to_cup',
    coffee_type: 'espresso',
    grind_size: 'wholebean',
  },
  {
    display: 'Cold Brew',
    subtitle: 'Coarse',
    image: 'https://res.cloudinary.com/pactcoffee/image/upload/v1617792589/website-d2c/assets/uploadedCMS/2021/Funnel/Cold_Brew.svg',
    value: 'cold brew',
    valueBE: 'cold_brew',
    coffee_type: 'brewed',
    grind_size: 'coarse',
  }
]

  const coffee_preparations = ref(coffee_preparations_base)
  const accordion_coffee_preparations = ref(accordion_coffee_preparations_base)


  function get_preparation(method) {
    return coffee_preparations.value.find((prep) => { return prep.display === method })
  }
  // expose managed state as return value
  return { coffee_preparations, accordion_coffee_preparations, get_preparation }
}
